<div class="sidebar-wrapper" [formGroup]="clientForm">
    <h2><strong>Client Settings:</strong> {{ selectedClient.name }}</h2>
    <!-- General Settings -->
    <div class="d-sm-flex flex-column">
        <h3>General</h3>

        <!-- Id Field (Read-only) -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Id</mat-label>
            <input matInput formControlName="id" readonly placeholder="Id">
        </mat-form-field>

        <!-- Name Field (Read-only) -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Name</mat-label>
            <input formControlName="name" matInput placeholder="Name" readonly>
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Logo</mat-label>
            <input formControlName="logo" matInput placeholder="Logo URL" readonly type="url">
        </mat-form-field>

        <!-- Description Field (Read-only) -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Description</mat-label>
            <textarea formControlName="description" matInput readonly rows="4"></textarea>
        </mat-form-field>

        <!-- Cookies to collect has been moved to IChatbotOptions -->

        <!-- Domain Field (Read-only) -->
        <mat-form-field appearance="fill" class="full-width">
            <mat-label>Domain</mat-label>
            <input formControlName="domain" matInput placeholder="Domain" readonly type="url">
        </mat-form-field>
    </div>

    <!-- AI API Settings section removed as it's now managed through shine-auth -->

    @if (isProductionConfigSyncAvailable) {
        <div class="d-sm-flex flex-column" [attr.aria-busy]="isSyncingProductionConfig">
            <h3>Environment Config</h3>

            <div class="d-flex justify-content-end">
                <button (click)="syncProductionConfig()"
                        [disabled]="isSyncingProductionConfig || isConfirmingProductionConfig"
                        color="primary"
                        mat-stroked-button
                        type="button">
                    <mat-icon aria-hidden="true">{{ isSyncingProductionConfig ? 'hourglass_top' : 'cloud_download' }}</mat-icon>
                    <span>{{ isSyncingProductionConfig ? 'Syncing...' : 'Get production config' }}</span>
                </button>
                @if (canImportConfigurationOnly) {
                    <button (click)="syncProductionConfig(false)"
                            [disabled]="isSyncingProductionConfig || isConfirmingProductionConfig"
                            mat-stroked-button type="button">
                        Replace local client from production
                    </button>
                }
            </div>
            <div role="status" aria-live="polite" aria-atomic="true">
                @if (isCheckingProductionConfig) {
                    <div class="config-sync-status config-sync-status--loading">
                        <mat-spinner [diameter]="24" aria-label="Checking configuration changes"></mat-spinner>
                        <p>{{ isPreparingLocalData ? 'Preparing missing local data… Existing local data is preserved.' : 'Checking which settings would be overwritten…' }}</p>
                    </div>
                } @else if (isSyncingProductionConfig) {
                    <div class="config-sync-status config-sync-status--loading">
                        <mat-spinner [diameter]="24" aria-label="Importing production configuration"></mat-spinner>
                        <div>
                            <strong>Importing configuration and checking local setup…</strong>
                            <p>Keep this panel open. The result will appear here when the import finishes.</p>
                        </div>
                    </div>
                } @else if (productionConfigSyncResult?.kind === 'success') {
                    <div class="config-sync-status config-sync-status--success">
                        <mat-icon aria-hidden="true">check_circle</mat-icon>
                        <p>{{ productionConfigSyncResult?.message }}</p>
                    </div>
                    @if (canReloadMirroredClient) {
                        <a mat-stroked-button color="primary" href="/ai/chatbots">
                            <mat-icon aria-hidden="true">refresh</mat-icon>
                            Reload Backoffice
                        </a>
                    }
                }
            </div>
            @if (productionConfigSyncResult?.kind === 'warning') {
                <div class="config-sync-status" role="alert">
                    <mat-icon aria-hidden="true">info</mat-icon>
                    <div><strong>Configuration imported — local setup needs attention</strong>
                        <p>{{ productionConfigSyncResult?.message }}</p></div>
                </div>
            }
            @if (productionConfigSyncResult?.kind === 'error') {
                <div class="config-sync-status config-sync-status--error" role="alert">
                    <mat-icon aria-hidden="true">error_outline</mat-icon>
                    <div>
                        <strong>Import not confirmed complete</strong>
                        <p>{{ productionConfigSyncResult?.message }}</p>
                    </div>
                </div>
            }
            @if (pendingProductFeeds.length) {
                <ul>
                    @for (feed of pendingProductFeeds; track feed.itemId) {
                        <li><a [routerLink]="['/ai/product-feeds', feed.itemId]">{{ feed.name || feed.itemId }}</a></li>
                    }
                </ul>
            }
        </div>
    }

    <div class="d-sm-flex flex-column">
        <h3>Conversation Settings</h3>
        <p class="text-muted mb-3">
            Conversation retention and categories now live in the Conversations page.
        </p>

        <div class="d-flex justify-content-end">
            <a [queryParams]="{tab: 3}"
               color="primary"
               mat-flat-button
               routerLink="/ai/conversations">
                <mat-icon>open_in_new</mat-icon>
                Open Conversations
            </a>
        </div>
    </div>
</div>
